export default __webpack_public_path__ + "static/media/library-tree-skeleton.9cb50d20.svg";